// extracted by mini-css-extract-plugin
export var readonly = "_gf-1";
export var star = "_gf-0";